<template>
    <div class="absolute">
        <div ref="wrapper" class="mx-auto w-[95vw] h-[85vh]">
            <svg :width="size.width" :height="size.height" id="svg_chart">
                <g v-if="dataset" class="bounds" :width="bounds.width" :height="bounds.height" :transform="`translate(${size.margin.left}, ${size.margin.top})`">
                    <rect v-for="(d, index) in this.dataset" :key="d[0]" :x="(size.rectWidth + size.padBetweenWidth) * index" :y="getY(d)" :width="size.rectWidth" :height="bounds.height - getY(d)" :fill="colors.orange"></rect>
                </g>
                <g id="xAxis" ref="xAxis" :transform="`translate(${size.margin.left}, ${bounds.height + size.margin.top})`"></g>
                <g id="yAxis" ref="yAxis" :transform="`translate(${size.margin.left}, ${size.margin.top})`"></g>
            </svg>
        </div>
    </div>
</template>

<script>
import * as d3 from 'd3'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../tailwind.config.js'
const fullConfig = resolveConfig(tailwindConfig)

export default {
    // 1. Access and parse data (data(), as a prop)
    // 2. Create chart dimensions (computed, because of resizing)?
    // 3. Render chart (template)
    // 4. Create scales (computed, bcause of data change)
    // 5. Render data (computed, bcause of data change)
    // 6. Render peripherals (computed, because of data change or resizing)
    // 7. Create and add interactions (template and computed)

    data() {
        return {
            publicPath: process.env.BASE_URL,
            dataset: null,
            hovered: null,
            chartLoaded: false,

            size: {
                width: 1920,
                height: 600,
                pad: 0.5,
                margin: {
                    left: 180,
                    right: 60,
                    top: 10,
                    bottom: 30,
                },
            },
            colors: {
                orange: fullConfig.theme.colors['orange'],
            },
            tooltipPos: {
                x: 0,
                y: 0,
            },
        }
    },

    async mounted() {
        const dataset = await d3.csv(this.publicPath + 'static/resumo-executivo/data/9_Propriedade-intelectual.csv')
        this.dataLoaded = true
        this.dataset = dataset
        this.init()
    },
    methods: {
        // Initialize functions
        init: function () {
            this.setSizes()
            this.axisGenerator()
        },

        // Sizes
        setSizes: function () {
            this.size.height = this.$refs.wrapper.clientHeight
            this.size.width = this.$refs.wrapper.clientWidth

            let padBetweenNo = this.dataset.length - 1
            let padBetweenWidth = (this.bounds.width / 100) * this.size.pad
            let padBetweenTotal = padBetweenNo * padBetweenWidth
            let rectWidth = (this.bounds.width - padBetweenTotal) / this.dataset.length

            this.size.rectWidth = rectWidth
            this.size.padBetweenWidth = padBetweenWidth
        },

        // Accessors
        xAccessor: function (d) {
            let val = parseInt(d['Ano do depósito'])
            return val
        },
        yAccessor: function (d) {
            let val = parseInt(d['Acumulado total'])
            return val
        },

        // Scales
        xScale: function (d) {
            const xScale = d3.scaleTime().domain(d3.extent(this.dataset, this.xAccessor)).range([0, this.bounds.width])
            return d ? xScale(d) : xScale
        },

        yScale: function (d) {
            const yScale = d3.scaleLinear().domain(d3.extent(this.dataset, this.yAccessor)).range([this.bounds.height, 0])
            return d ? yScale(d) : yScale
        },

        // Axis
        axisGenerator() {
            const xAxisGenerator = d3.axisBottom().scale(this.xScale()).tickFormat(d3.format('d'))
            const xAxis = d3.select(this.$refs.xAxis).call(xAxisGenerator)
            xAxis.attr('class', 'graph_axis graph_x_axis')

            const yAxisGenerator = d3.axisLeft().scale(this.yScale())
            const yAxis = d3.select(this.$refs.yAxis).call(yAxisGenerator)
            yAxis.attr('class', 'graph_axis graph_y_axis')
        },

        // Animation
        animateChart() {
            const animatedLineGenerator = d3
                .line()
                .x((d) => this.xScale(this.xAccessor(d)))
                .y((d) => this.yScale(this.yAccessor(d)))
            d3.select('#test').transition().duration(500).style('stroke', 'red').attr('d', animatedLineGenerator(this.dataset))
        },
        getY: function (d) {
            let val = this.yScale(this.yAccessor(d))
            return val
        },
    },
    watch: {},

    computed: {
        // Calculate bounds based on window size
        bounds: function () {
            return {
                width: this.size.width - this.size.margin.left - this.size.margin.right,
                height: this.size.height - this.size.margin.top - this.size.margin.bottom,
            }
        },
    },
}
</script>

<style scoped>
#xAxis,
#yAxis {
    /* color: red; */
    @apply font-sans text-xl;
}
circle:hover {
    fill: red;
    cursor: pointer;
}
.wrapper_style {
    position: absolute;

    width: 80%;
    height: 500px;
}

.graph_line {
    fill: none;
    stroke: black;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
